/* eslint-disable no-await-in-loop */
import React, { Component } from 'react';
import swal from 'sweetalert2';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { unescape } from 'lodash';
import FontFamily from './font-family/FontFamily';
import FontSize from './font-size/FontSize';
import FontColor from './font-color/FontColor';
import DeleteBtn from './delete-btn/DeleteBtn';
import TextInput from './text-input/TextInput';
import { postTextData } from './../../redux/helpers/texts';
import './TextTools.css';
import { tableNumber, placeCard, setGeneratedTextToCorrectPosition } from '../../helpers/weddingHelper';

import { getCurrentLayout } from '../../redux/helpers';
import { changeEveryTextProperty, changeTextProperty } from '../../redux/actions/entities/texts';
import { store } from '../..';


class TextTools extends Component {
  constructor(...args) {
    super(...args);
    this.state = ({
      collapsed: false,
    });
  }

  async componentDidUpdate(prevProps) {
    const {
      texts,
      bookProperties,
      lang,
      pages,
      layouts,
    } = this.props;
    const { texts: prevTexts } = prevProps;
    const activeTextField = Object.values(texts).find(element => element.isActive);
    const prevTextField = Object.values(prevTexts).find(element => element.isActive);


    if (activeTextField && activeTextField.images && prevTextField) {
      const { productID } = bookProperties;
      if (activeTextField.text === '') {
        return null;
      }
      if (
        prevTextField.color !== activeTextField.color ||
        prevTextField.fontSize !== activeTextField.fontSize ||
        prevTextField.font !== activeTextField.font ||
        unescape(prevTextField.text) !== unescape(activeTextField.text)
      ) {
        const data = {
          id: activeTextField.id,
          text: unescape(activeTextField.text),
          fontSize: activeTextField.fontSize,
          font: activeTextField.font,
          color: activeTextField.color,
          ratio: 1,
          bookId: productID,
          context: 'consumer',
          type: activeTextField.type,
        };

        const activePage = Object.values(pages).find(el => el.isActive);
        const currentLayout = getCurrentLayout(layouts, activePage.layout);
        const { type } = currentLayout;
        if ((unescape(prevTextField.text) === unescape(activeTextField.text)) && (type === tableNumber || type === placeCard)) {
          swal({
            title: lang.warning,
            text: lang.tableNumberQuestion,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: lang.tableNumberYes,
            cancelButtonText: lang.tableNumberOnlyOne,
            reverseButtons: true,
          }).then(async (result) => {
            if (result.value) {
              for (const [index, text] of Object.entries(texts)) {
                const Textsdata = Object.assign({}, data, {
                  id: text.id,
                  text: unescape(text.text),
                });
                await postTextData(Textsdata, this.props.dispatch);
              }
              setGeneratedTextToCorrectPosition(store);
              this.getModifiedProp(texts, prevTexts);
            } else if (result.dismiss === swal.DismissReason.cancel) {
              const currentPage = Object.values(pages).find(el => el.isActive);
              if (currentPage && 'texts' in currentPage) {
                for (const [index, text] of Object.entries(currentPage.texts)) {
                  const Textsdata = Object.assign({}, data, {
                    id: text,
                    text: unescape(texts[text].text),
                  });
                  await postTextData(Textsdata, this.props.dispatch);
                }
              }
            }
          });
        } else {
          for (const [index, text] of Object.entries(texts)) {
            const { type: dataType } = data;

            if (dataType === text.type) {
              const Textsdata = Object.assign({}, data, {
                id: text.id,
                text: unescape(text.text),
                fontSize: text.fontSize,
              });
              await postTextData(Textsdata, this.props.dispatch);
              this.props.dispatch(changeTextProperty(text.id, 'font', data.font));
              this.props.dispatch(changeTextProperty(text.id, 'color', data.color));
            }
          }
        }
      }
    }
  }

  getModifiedProp = (texts, prevTexts) => {
    const props = ['font', 'color', 'fontSize'];
    const { dispatch } = this.props;
    for (const text in texts) {
      if (text in texts) {
        const element = texts[text];
        const prevElement = prevTexts[text];

        props.forEach((prop) => {
          if (element[prop] !== prevElement[prop]) {
            return dispatch(changeEveryTextProperty(prop, element[prop]));
          }
          return true;
        });
      }
    }
  }

  handleCollapse = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const {
      lang,
      texts,
    } = this.props;

    const isSpineText = Object.values(texts).some(element => element.isSpineText && element.isActive);
    const activeTextField = Object.values(texts).find(element => element.isActive);
    if (!activeTextField) {
      return null;
    }

    const {
      isEditable,
      disableTools,
    } = activeTextField;

    if (disableTools !== undefined && disableTools) {
      return <div />;
    }

    const TextIsEditable = isEditable || isEditable === undefined;


    return (
      <div className={`toolbarContainer ${activeTextField ? 'active' : ''}`}>
        <div className="col text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 15 16"
            enableBackground="new 0 0 15 16"
            xmlSpace="preserve"
          >
            <path d="M6.5,3.7L8.6,9H4.4L6.5,3.7z M7,0L1,15H0v1h3v-1H2l2-5h5l2,5h-1v1h5v-1h-1L8,0H7z" />
          </svg>
          <h2>{lang.insert_text}</h2>
          <button onClick={this.handleCollapse} className="collapse-btn">
            <i className={`fa ${!this.state.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'}  `} />
          </button>
        </div>
        <div className={`collapse-body ${this.state.collapsed ? 'collapse' : ''} `}>

          { (TextIsEditable) &&
            <div className="col">
              <FontFamily
                textFieldId={activeTextField.id}
                font={activeTextField.font}
                lang={lang}
              />
            </div>
          }

          { (TextIsEditable) && !isSpineText &&
            <div className="col">
              <FontSize
                textFieldId={activeTextField.id}
                fontSize={activeTextField.fontSize}
              />
            </div>
          }

          { (TextIsEditable) && <FontColor
            textFieldId={activeTextField.id}
            color={activeTextField.color}
          />
          }

          <TextInput
            textFieldId={activeTextField.id}
            text={unescape(activeTextField.text)}
            isOverflow={activeTextField.isOverflow}
            lang={lang}
          />
          {(TextIsEditable) &&
            <DeleteBtn
              textFieldId={activeTextField.id}
            />
          }
        </div>
      </div>
    );
  }
}

TextTools.defaultProps = {
  lang: {},
  texts: {},
  bookProperties: {},
  dispatch: () => {},
  pages: {},
  layouts: {},
};

TextTools.propTypes = {
  lang: PropTypes.object,
  texts: PropTypes.object,
  bookProperties: PropTypes.object,
  dispatch: PropTypes.func,
  pages: PropTypes.object,
  layouts: PropTypes.object,
};

export default connect(state => ({
  texts: state.entities.texts,
  editorUI: state.editorUI.canvas,
  bookProperties: state.bookProperties,
  pages: state.entities.pages.byId,
  layouts: state.entities.layouts.byId,
}))(TextTools);



// WEBPACK FOOTER //
// ./src/components/text-tools/TextTools.jsx